// Sidebar.js
import React from "react";

const Sidebar = ({ setActiveTab }) => {
  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 bg-dark text-white" style={{ width: "250px", height: "100vh" }}>
      <h4 className="text-center">Admin Panel</h4>
      <ul className="nav nav-pills flex-column mb-auto mt-4">
        <li className="nav-item">
          <button className="nav-link text-white" onClick={() => setActiveTab("dashboard")}>Dashboard</button>
        </li>
        <li>
          <button className="nav-link text-white" onClick={() => setActiveTab("manageCategory")}>Manage Category</button>
        </li>
        <li>
          <button className="nav-link text-white" onClick={() => setActiveTab("manageProduct")}>Manage Product</button>
        </li>
        {/* <li>
          <button className="nav-link text-white" onClick={() => setActiveTab("manageOrders")}>Manage Orders</button>
        </li>
        <li>
          <button className="nav-link text-white" onClick={() => setActiveTab("manageUsers")}>Manage Users</button>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar;
